<template>
  <div>

    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" style="padding: 0; margin: 0" size="medium">
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.name" @keyup.enter.native="handleSearch" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="finishAdjust">完成</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <h5>总金额：{{ total_price }}</h5>
      <el-col :span="24">
        <el-tabs type="border-card" @tab-click="getTabValue">
          <el-tab-pane v-for="(item, index) in firstTypeList" :key="index" :label="item.NAME" :code="item.INNER_CODE">
          </el-tab-pane>
          <div class="el-tabs__content">
            <el-table :data="tableData" stripe border style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
              <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
              <el-table-column prop="TYPE_UNIT" label="单位" min-width="70"></el-table-column>
              <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="70"></el-table-column>
              <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
              <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="70"></el-table-column>
              <el-table-column label="保质期" min-width="70">
                <template slot-scope="scope">
                  <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="PRODUCT_COUNT" label="库存数量" min-width="45"></el-table-column>
              <el-table-column prop="PRODUCT_WORTH" label="剩余价值" min-width="45"></el-table-column>
              <el-table-column label="出库数量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.defaultCount" @focus="getCloumnScope(scope.row)" :disabled="disabledBtn(scope.row)"
                    @change="addOutCountList" @clear="clearCountInput(scope.row)" :placeholder="scope.row.PRODUCT_COUNT" clearable>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-circle-check-outline" @click="submitAdjust(scope.row)" :disabled="disabledBtn(scope.row)">
                    确认
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tabs>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  queryWarehouseFun, queryFirstFun,
} from 'api/warehouseManager';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      loading: false,
      exportForm: {},
      firstList: [],
      secondList: [],
      returnVisible: false,
      showStatus: 0,
      returnForm: {},
      count: 0,
      showAll: true,
      searchForm: {},
      firstTypeList: [],
      TAB_CODE: '',
      total_price: 0,
      tableData: [],
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      addForm: {},
      formLabelWidth: '120px',
      unpackingVisible: false,
      lossForm: {},
      lossVisible: false,
      addBoxVisible: false,
      addBoxForm: {},
      addListVisible: false,
      addBoxList: [],
      addVisible: false,
      pickerOptions: [],
      exportRecordVisible: false,
      exportRecordForm: {},
      // 当前行数据
      currentRow: {},
      // 依据PRODUCT_CODE判断是否点击确认
      PRODUCT_CODE_LIST: [],
      // 当前输入的产品出库数量
      snapProductList: [],
      // 当前获取的出库单凭
      currentProduct: {},
      // 出库的商品列表
      PRODUCTS: [],
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
  },
  mounted() {
    if (this.SAVE_STOCKLIST) {
      this.searchForm = this.SAVE_STOCKLIST.CONDITION;
      this.currentPage = this.SAVE_STOCKLIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.showStatus = 0;
    this.clickfirstType();
    this.queryStockList();
  },
  computed: {
    // 上一次的搜索结果和条件
    SAVE_STOCKLIST() {
      return this.$store.state.SAVE_STOCKLIST;
    },
  },
  methods: {
    finishAdjust() {
      this.$router.push({
        path: `/adjust_out_detail/${this.$route.params.id}`,
        params: { id: this.$route.params.id },
      });
    },
    // 聚焦获取行数据
    getCloumnScope(row) {
      this.currentRow = row;
    },
    disabledBtn(row) {
      return (
        this.PRODUCT_CODE_LIST.includes(`${row.BATCH}_${row.LOCATION_ID}`) || Number(row.PRODUCT_COUNT) === 0
      );
    },
    // 将出库数据添加到列表中
    addOutCountList(count) {
      this.currentProduct = {};
      if (/^\s+''$/g.test(count) || count.length === 0) {
        // 清空输入框后将数组中的元素清除
        this.PRODUCTS.forEach((item, index) => {
          if (this.currentRow.PRODUCT_CODE === item.PRODUCT_CODE) {
            this.PRODUCTS.splice(index, 1);
            this.PRODUCT_CODE_LIST.splice(index, 1);
          }
        });
      } else if (Number(this.currentRow.PRODUCT_COUNT) >= Number(count)) {
        this.currentRow.SUB_COUNT = Number(count);
        this.currentRow.defaultCount = Number(count);
        this.snapProductList.push(this.currentRow);
      } else {
        this.$message.show({ text: '库存数量不足', type: 'warning' });
      }
    },
    // 点击清空输入框触发 PRODUCT_CODE defaultCount
    clearCountInput(row) {
      this.snapProductList.forEach((item, index) => {
        if (item.PRODUCT_CODE === row.PRODUCT_CODE) {
          this.PRODUCTS.splice(index, 1);
          this.snapProductList.splice(index, 1);
          this.PRODUCT_CODE_LIST.splice(index, 1);
        }
      });
    },
    // 点击确认提交添加的菜品
    submitAdjust(row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.defaultCount)) {
        this.$message.show({ text: '请输入正数', type: 'error' });
        return false;
      }
      if (Number(row.PRODUCT_COUNT) < row.defaultCount) {
        this.$message.show({ text: '库存数量不足', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10061',
        OTYPE: 2,
        TRANSFER_ID: Number(this.$route.params.id),
        PRODUCT_CODE: row.PRODUCT_CODE,
        BATCH: row.BATCH,
        PRODUCT_COUNT: row.SUB_COUNT,
        SRC_GYS_ID: Number(sessionStorage.getItem('tcId')),
        LOCATION_ID: row.LOCATION_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.snapProductList.forEach((item) => {
          if (row.BATCH === item.BATCH && row.LOCATION_ID == item.LOCATION_ID) {
            if (Number(item.PRODUCT_COUNT) >= row.defaultCount) {
              this.PRODUCTS.push(item);
              this.PRODUCT_CODE_LIST.push(`${item.BATCH}_${item.LOCATION_ID}`);
            } else {
              this.$message.show({ text: '库存数量不足', type: 'warning' });
            }
          }
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getStorageList();
    },
    // -----------------------------筛选功能
    handleSearch() {
      this.currentPage = 1;
      this.queryStockList();
    },
    queryStockList() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
        FLAG: 0,
      };
      if (this.searchForm.name) params.PRODUCT_NAME = this.searchForm.name;
      this.loading = true;
      queryWarehouseFun(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE.map((item, index) => Object.assign(item, { CXCOUNT: item.CXCount }));
        if (result[0].TOTAL_WORTH !== '') {
          this.total_price = result[0].TOTAL_WORTH;
        } else {
          this.total_price = 0;
        }
        this.loading = false;
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loading = false;
        });
    },
    // ----------------------------------------获取全部一级大类
    clickfirstType() {
      queryFirstFun().then((result) => {
        if (result[0]) {
          this.firstTypeList = result;
          this.firstList = result;
          this.TAB_CODE = result[0].INNER_CODE;
          this.getStorageList();
          this.handleSearch();
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ------------------------------------------点击一级大类获取一级大类内容
    getStorageList() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
        FLAG: 0,
      };
      if (this.TAB_CODE > 99 || this.TAB_CODE == -1) {
        if (this.TAB_CODE) {
          params.FIRST_CATALOG_CODE = this.TAB_CODE;
        }
      }
      if (this.searchForm.name) params.PRODUCT_NAME = this.searchForm.name;
      queryWarehouseFun(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE.map((item, index) => Object.assign(item, { CXCOUNT: item.CXCount }));
        if (result[0].TOTAL_WORTH !== '') {
          this.total_price = result[0].TOTAL_WORTH;
        } else {
          this.total_price = 0;
        }
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_SAVE_STOCKLIST', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getTabValue(tab, event) {
      this.TAB_CODE = tab.$attrs.code;
      this.currentPage = 1;
      this.getStorageList();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/adjust_product.vue